const ViewState = {
	ALL: "all",
	THREAD: "thread",
	NEW: "new"
};
export default ViewState;
